export const ELLIPSIS = 'ellipsis' as const;

export type PaginationItem = number | typeof ELLIPSIS;

/**
 * The page numbers to show: always the first and last page, and a run around
 * the current one, with an ellipsis for each gap. `maxNumbers` caps how many
 * numbers appear, ellipses aside, so the row fits its space.
 *
 * With 18 pages and a cap of 9 this gives 1 2 3 4 5 6 7 8 … 18, and with a cap
 * of 3 it gives 1 2 … 18, matching the desktop and mobile designs.
 */
export const getPaginationItems = (
  currentPage: number,
  totalPages: number,
  maxNumbers: number,
): PaginationItem[] => {
  if (totalPages <= maxNumbers) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  // Slots between the first and the last page.
  const innerCount = Math.max(1, maxNumbers - 2);
  const start = Math.min(
    Math.max(currentPage - Math.floor((innerCount - 1) / 2), 2),
    totalPages - innerCount,
  );
  const end = start + innerCount - 1;
  const inner = Array.from({ length: innerCount }, (_, index) => start + index);

  return [
    1,
    ...(start > 2 ? [ELLIPSIS] : []),
    ...inner,
    ...(end < totalPages - 1 ? [ELLIPSIS] : []),
    totalPages,
  ];
};
